module.exports = __webpack_public_path__ + "img/logo-color.c13eabc.png";